import React from 'react'

const Header = () => {
  return (
    <h2>Flousi</h2> 
  )
}

export default Header